// 1) Yardımcı sözlük: liman adına göre O(1) erişim
// src/data/portsMap.js
import popularPorts from '../data/popularPorts';
export const portsByName = Object.fromEntries(
    popularPorts.map(p => [p.name, p])   // { 'Mersin': { name, country:'TR', ... } }
);
